/*
We're constantly improving the code you see.
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from 'react'

export const GotoIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
    >
      <path
        d="M4.90609 7.02938L0.372417 11.7333C0.133886 11.9823 -1.4695e-07 12.3191 -1.1626e-07 12.6701C-8.55704e-08 13.0212 0.133886 13.358 0.372417 13.6069C0.491475 13.7315 0.633121 13.8303 0.789186 13.8978C0.945251 13.9653 1.11265 14 1.28171 14C1.45078 14 1.61818 13.9653 1.77424 13.8978C1.93031 13.8303 2.07195 13.7315 2.19101 13.6069L7.62117 7.97283C7.74121 7.8493 7.83649 7.70233 7.9015 7.54041C7.96652 7.37848 8 7.2048 8 7.02938C8 6.85396 7.96652 6.68028 7.9015 6.51835C7.83649 6.35643 7.74121 6.20946 7.62117 6.08593L2.19101 0.385377C2.07134 0.262222 1.92942 0.164788 1.77338 0.098661C1.61734 0.0325332 1.45026 -0.000987434 1.28171 2.34755e-05C1.11316 -0.000987405 0.946081 0.0325333 0.790044 0.0986611C0.634007 0.164788 0.492085 0.262222 0.372416 0.385378C0.133885 0.634345 -1.13902e-06 0.971131 -1.10833e-06 1.32218C-1.07764e-06 1.67323 0.133885 2.01002 0.372416 2.25899L4.90609 7.02938Z"
        fill="#7E92A2"
      />
    </svg>
  )
}
